import React from 'react';
import ActionButton from '../../builder/ActionButton';
import { getRemotedbUrl } from '../../../lib/ep';

const Telegram = (props) => {
	const post = props?.post ?? null;
	const url = props?.url ?? null;
	const share = props?.share ?? {};

	const click = () => {
		const linkable = props?.linkable ?? true;
		if(!linkable) return;

		const ua = navigator.userAgent.toLowerCase();
		const isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
		const url_store = (isAndroid) ? "market://details?id=org.telegram.messenger" : "http://itunes.apple.com/us/app/telegram-messenger/id686449807?mt=8";

		var now = new Date().valueOf();
		setTimeout(() => {
			if(new Date().valueOf() - now > 100) return;
			window.location = url_store;
		}, 500);

		if(share.promotion_id != undefined) {
			$.post(getRemotedbUrl(`/users/sharebtn/${share.promotion_id}`), {
				network:7,
				page:share.page,
				type:share.type,
				uid:share?.user_id ?? null,
			});
		}

		//window.location = `tg://msg?text='${post}${url}`;
		window.location = `https://t.me/share/url?url=${url}&text=${post}`;
		
	};

	return (
		<ActionButton
			{...props}
			icon='ep-telegram is_telegram'
			_target="parent"
			onClick={() => click()}
		/>
	)
}

export default Telegram;